<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'PFormationPourquoiSeFormer'
});
</script>
<template>
  <ka-container
    code="p-formation-pourquoi-se-former"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Texte gauche -->
    <ka-container code="texte-gauche">
      <ka-text code="h-2">
        <h2 v-html="componentInstance.$text.value" />
      </ka-text>
      <ka-text
        code="text-1"
        :value="componentInstance.$text1.value" />
    </ka-container>
    <ka-image
      code="image"
      :options="{
        animationIn: `fadeIn`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        imgFit: `cover`
      }"
      :value="componentInstance.$image.value" />
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { pFormationPourquoiSeFormerComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c25')
const component = pFormationPourquoiSeFormerComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  text?: Nullable<string>
  text1?: Nullable<string>
  image: string | File
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  text: '<strong>Pourquoi se former en marketing digital et comment ?</strong>',
  text1: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  image: 'https://ucarecdn.com/a13650b4-05a9-48d3-883a-bdf40fe0dd27/',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:text',
  'update:text1',
  'update:image'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    text: true,
    text1: true,
    image: true
  }
})
</script>
